<template>
  <div id="matterList">
    <div class="header">
      <div class="department-select">
        <p class="select-result">
          <span :class="{ 'open': open && selectorType == 'department' }" @click="selectorHandle('department')">{{
              params.orgName && selectorObj.orgName != '' ? params.orgName : '所有部门'
          }}</span>
        </p>
        <p class="select-result">
          <span :class="{ 'open': open && selectorType == 'servicer' }" @click="selectorHandle('servicer')">{{
              params.fwdxName && params.fwdxName != '' ? params.fwdxName : '事项分类'
          }}</span>
        </p>
        <DepartmentSelector v-show="open && selectorType == 'department'" :selectorObj='selectorObj' :list="orgArray" @getAllOff="getAllOff"
          @selectedOrg="selectedOrg" @selectedDepartment="selectedDepartment" @fixedSelector="fixedSelector(1)"
          :itemType="itemType"></DepartmentSelector>
        <ServiceObject :selectOption="selectOption" :dataList="servicers" v-if="open && selectorType != 'department'"
          @serviceObjectHandle="serviceObjectHandle" @fixedSelector="fixedSelector(2)"></ServiceObject>
      </div>
      <div class="search-bar">
        <!-- <div class="search-box">
          <van-icon class="search-icon iconfont" class-prefix="icon" name="sousuo"></van-icon>
          <form action="javascript:void(0)"><input type="search" v-model="query.inventoryName" placeholder="请输入事项名称"
              @keydown="searchHandle" /></form>
        </div> -->
        <van-search v-model="query.inventoryName" :clearable="false" placeholder="请输入事项名称" @keydown="searchHandle" style="width:85%;border-radius: 20px;"/>
        <p class="assistant" @click="searchHandle">搜索</p>
      </div>
    </div>

    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" v-if="list.length > 0"
      :immediate-check="false">
      <div class="box">
        <ServiceItemLandscape v-for="(item, index) in list" :key="index" :data="item" @matterHandle="matterHandle" />
      </div>
    </van-list>
    <Error :type="'empty'" v-else></Error>
    <div class="dialog-bg" v-if="open" @click="close"></div>
  </div>
</template>

<script>
import http from "@/utils/http";
import { Toast } from "vant";
import { queryMattersDepartments, queryMobileItemListsData, QUERY_SERVICE_DATA, QUERY_THING_SHAPE_DATA } from "@/api/three-list/index";
export default {
  components: {
    DepartmentSelector: () => import('./components/DepartmentSelector'),
    ServiceObject: () => import('./components/ServiceObject'),
    ServiceItemLandscape: () => import("./components/ServiceItemLandscape"),
  },
  props: {
    itemType: {
      type: Number,
    }
  },
  data() {
    return {
      open: false,
      params: {
        sxmcLike: '',//事项名称
        orgId: '',//部门id
        orgName: '',
        fwdxId: '',//服务对象id
        fwdxName: '',
        sxxzId: '',//事项性质id
        sxxzName: '',
        blmsId: '',//办理模式id
        blmsName: '',
        sxbhLike: ''//事项编号搜索内容
      },
      selectorType: '',
      selectorObj: {
        orgSelector: 1,
        selectId: '',
        departmentSelector: null
      },
      selectOption: null,
      orgArray: [],
      servicers: [],
      eventArray: [],
      patterns: [],
      list: [],
      emptyShow: false,
      query: {
        itemType: 1,
        pageIndex: 0,
        pageSize: 10,
        organId: '',
        classifiedId: '',
        inventoryName: ''
      },
      loading: false,
      finished: false,
      pageDetails: null,
    }
  },
  created() {
    this.init();
  },
  watch: {
    itemType(newValue) {
      this.query.inventoryName = '';
      this.query.itemType = newValue;
      this.query.organId = '';
      this.query.pageIndex = 0;
      this.query.pageSize = 10;
      this.query.classifiedId = '';
      this.params.orgName = '';
      this.list = [];
      this.loading = false;
      this.finished = false;
      this.getData();
    }
  },
  mounted() {
    this.query.itemType = this.itemType;
  },
  methods: {
    getAllOff(){
      this.selectorObj.departmentSelector = null;
      // 获取全部部门
    },
    async onLoad() {
      if ((this.pageDetails.currentPage) == this.pageDetails.totalPage) {
        this.finished = true;
        return;
      }
      this.query.pageIndex++;
      await this.getData();
      this.loading = false;
      // if ((this.pageDetails.currentPage + 1) == this.pageDetails.totalPage) {
      //   this.finished = true;
      // }
    },
    // 事项分类
    getShape() {
      return QUERY_THING_SHAPE_DATA({
        pantId: this.query.organId
      })
    },
    // 初始化
    init() {
      //获取数据字典
      this.getDectionary();
    },
    // 获取事项列表数据
    getData() {
      this.emptyShow = false;
      this.mixinShowLoading();
      QUERY_SERVICE_DATA(this.query).then(res => {
        if (res.code && res.code == 200) {
          this.pageDetails = res.data;
          this.list = this.list.concat(res.data.data);
          this.list.length > 0 ? this.emptyShow = false : this.emptyShow = true
          this.mixinClearLoading();
        }
      })
    },
    // 列表点击事件
    matterHandle(item) {
      this.$router.push('/serviceHall/detail/' + item.pcTerminal)
    },
    // 机构点击赋值
    selectedOrg(val) {
      this.selectorObj.orgSelector = val;
    },
    // 部门点击赋值
    selectedDepartment(val) {
      this.selectorObj.departmentSelector = val;
    },
    // 服务对象、事项性质、办理模式选择器点击调用事件
    serviceObjectHandle(val) {
      this.selectOption = val;
    },
    // 确定选择调用事件
    fixedSelector(type) {
      this.query.inventoryName = '';
      this.finished = false;
      this.query.pageIndex = 0;
      this.list = [];
      // 部门选择
      if (type == 1) {
        this.query.organId = this.params.orgId = this.selectorObj.departmentSelector !== null ? this.selectorObj.departmentSelector.id : '';
        this.params.orgName = this.selectorObj.departmentSelector !== null ? this.selectorObj.departmentSelector.organName : '所有部门';
        this.query.classifiedId = '';
        this.selectOption = null;
      }
      //点击事项分类
      if (this.selectOption != null && type == 2) {
        this.query.classifiedId = this.selectOption.id
      }
      this.getData();
      this.open = false;
    },
    // 选择器点击事件
    async selectorHandle(selectorType) {

      if (selectorType == 'servicer' && this.query.organId == '') {
        Toast({
          message:'请先选择部门！',
          className:'z-index'
        });
        return;
      }
      if (selectorType == 'servicer' && this.query.organId !== '') {
        const RES = await this.getShape();
        this.servicers = RES.data;
        if (RES.data.length == 0) {
          Toast({
          message:'该部门暂无事项分类！',
          className:'z-index'
        });
          return;
        }
      }
      if (selectorType != this.selectorType) {
        this.selectorType = selectorType;
        this.openSelector()
      } else {
        if (this.open) {
          this.close()
        } else {
          this.openSelector();
        }
      }
    },
    // 搜索
    searchHandle() {
      this.finished = false;
      this.query.pageIndex = 0;
      this.list = [];
      this.getData();
    },
    // 打开选择器弹窗
    openSelector() {
      this.open = true;
    },
    // 关闭选择器弹窗
    close() {
      this.open = false;
      this.selectOption = null;
    },
    //  获取数据字典
    getDectionary() {
      // const keys = [
      //   'listOrgType',//部门类别
      //   'XJDITEMLIST_FWDXM', //服务对象
      //   'XJDITEMLIST_SXXZM', //事项性质
      //   'XJDITEMLIST_BJMSM', //办理模式
      // ];
      http.post('nonlogin/organ/findtreeMobile.htm?size=3').then(res => {
        this.orgArray = res;
        this.getData();
        // this.servicers = res;
      })
      // http.get('/param/keys.htm', {keys: keys.join()}).then(resp=>{
      //   if (!resp || resp.code != 200) {
      //     Toast(`获取系统参数${dictionaryKey}失败`)
      //   } else {
      //     keys.forEach((item, index) => {
      //       let array = [];
      //       if (typeof resp.data[item] == 'string') {
      //         array = JSON.parse(resp.data[item])
      //       } else {
      //         array = resp.data[item]
      //       }
      //       if(index == 0) {
      //         this.orgArray = array;
      //         this.orgArray.forEach((jtem, idx) => {
      //           queryMattersDepartments({typeId: jtem.id}).then(res => {
      //             if(res.code && res.code == 200) {
      //               this.$set(this.orgArray[idx], 'list', res.data || []);
      //               this.selectorObj.orgSelector = jtem;
      //               if(this.orgArray[idx].list.length > 0) {
      //                 this.selectorObj.departmentSelector = this.orgArray[idx].list[0];
      //                 this.params.orgId = this.selectorObj.departmentSelector.ORGID;
      //                 this.params.orgName = this.selectorObj.departmentSelector.ORGNAME;
      //                 this.getData();
      //                 return
      //               }
      //             }
      //           })
      //         })
      //       } else if(index == 1) {
      //         this.servicers = array;
      //       } else if(index == 2) {
      //         this.eventArray = array;
      //       } else if(index == 3) {
      //         this.patterns = array;
      //       }
      //     })
      //   }
      // });
    },
  }
}
</script>

<style lang="scss">
@import "~@/assets/css/theme/theme.scss";
#matterList {
  .header {
    background: #fff;
    position: fixed;
    top: 60px;
    left: 0;
    width: 100%;
    z-index: 998;
    .search-bar {
      width: 100%;
      height: 44px;
      padding: 8px 15px;
      box-sizing: border-box;
      display: -webkit-flex;
      /* Safari */
      display: flex;
      background: #fff;
      color: $c333;

      .search-box {
        height: 28px;
        line-height: 28px;
        padding: 0 15px 0 35px;
        background: #F7F7F7;
        border: 1px solid #FFFFFF;
        border-radius: 14px;
        flex: 1;
        position: relative;
        @extend .font13;

        .search-icon {
          position: absolute;
          top: 0;
          left: 15px;
        }

        form {
          width: 100%;
          background: transparent;
          height: 28px;
          line-height: 28px;
          padding: 0;

          input {
            float: left;
            width: 100%;
            height: 28px;
            line-height: 28px;
            background: transparent;
            @extend .font13;

            &::-webkit-search-cancel-button {
              -webkit-appearance: none;
            }
          }
        }
      }

      .assistant {
        height: 28px;
        line-height: 28px;
        margin-left: 15px;
        @extend .font16;
      }
    }

    .department-select {
      font-size: 0;
      background: #fff;
      box-sizing: border-box;
      padding: 12px 15px 12px;
      border-bottom: 1px solid #F0F0F0;
      position: relative;
      z-index: 999;

      .select-result {
        display: inline-flex;
        width: 25%;
        height: 24px;
        line-height: 24px;
        box-sizing: border-box;
        padding: 0 8px;
        @extend .color333;
        @extend .font14;

        span {
          display: inline-block;
          width: 100%;
          height: 24px;
          line-height: 24px;
          padding-right: 12px;
          box-sizing: border-box;
          position: relative;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;

          &:after {
            content: "";
            display: inline-block;
            border: 4px solid transparent;
            border-bottom: 4px solid #333;
            position: absolute;
            right: 0;
            top: 50%;
            transform: rotate(180deg);
            margin-top: -2px;
          }

          &.open:after {
            transform: rotate(0deg);
            margin-top: -9px;
          }
        }
      }
    }
  }

  .box {
    padding: 0 15px;
    margin-top: 104px;
  }

  .empty {
    margin-top: 100px;
  }

  .selector-box {
    top: 37px !important;
  }

  .dialog-bg {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 997;
    background: rgba(0, 0, 0, .7);
  }
}
.search-bar input::placeholder{
  color: #666666!important;
}

</style>
